export const AUTH_ERROR_MESSAGES = {
  INVALID_EMAIL_OR_PASSWORD: "Email or password is incorrect.",
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: "An account with this email already exists.",
  ORGANIZATION_ALREADY_EXISTS: "Team name already taken — pick another.",
  INVALID_TOKEN: "Reset link is invalid or expired. Request a new one.",
  PASSWORD_TOO_SHORT: "Password must be at least 8 characters.",
} as const;

export type AuthErrorCode = keyof typeof AUTH_ERROR_MESSAGES;

function extractCode(err: unknown): string | undefined {
  if (!err || typeof err !== "object") return undefined;
  const e = err as { code?: string; error?: { code?: string } };
  return e.code ?? e.error?.code;
}

export function friendlyAuthError(err: unknown, fallback = "Something went wrong"): string {
  const code = extractCode(err);
  if (code && code in AUTH_ERROR_MESSAGES) {
    return AUTH_ERROR_MESSAGES[code as AuthErrorCode];
  }
  if (err && typeof err === "object") {
    const e = err as { message?: string; error?: { message?: string } };
    return e.message || e.error?.message || fallback;
  }
  return fallback;
}

export function isOrgAlreadyExists(err: unknown): boolean {
  return extractCode(err) === "ORGANIZATION_ALREADY_EXISTS";
}
